// extracted by mini-css-extract-plugin
export default {"wrapper":"t3-z","play":"u3-z"};